interface Discount {
  id: string
  code: string
  description: string
  type: 'fixed' | 'percentage'
  quantity: number
  store_ids: string[]
  target: 'all_products' | 'product_variant'
  trigger: 'manual' | 'automatic'
  quantity_per_customer: number
  published_at: string | null
  start_date: string | null
  end_date: string | null
}

export enum DiscountType {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
  LOYALTY = 'LOYALTY'
}

export enum DiscountFilter {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SCHEDULED = 'SCHEDULED'
}

export enum DiscountTarget {
  ALL_CHARGES = 'ALL_CHARGES',
  ALL_PRODUCTS = 'ALL_PRODUCTS',
  CATEGORY = 'CATEGORY',
  DELIVERY_FEE = 'DELIVERY_FEE',
  ORDERED_AT = 'ORDERED_AT',
  ORDER_ABOVE = 'ORDER_ABOVE',
  PRODUCT = 'PRODUCT',
  PRODUCT_VARIANT = 'PRODUCT_VARIANT',
  STORE = 'STORE',
  SUBTOTAL_DELIVERY_FEE = 'SUBTOTAL_DELIVERY_FEE',
  VARIANT_OR_CATEGORY = 'VARIANT_OR_CATEGORY'
}

export type { Discount }
